import * as React from 'react';
import { Button } from '@mui/material';
import { Queue } from '@mui/icons-material';

/**
 * A reusable button that opens the Queue Upload page in a new browser tab.
 */
export const OpenQueueUploadButton: React.FC = () => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        window.open('/QueueUpload', '_blank');
    };

    return (
        <Button size="small" onClick={handleClick} startIcon={<Queue color="success" />}>
            Queue List
        </Button>
    );
};
